import React from 'react';

const LoadingSkeleton = ({ viewMode = 'list', count = 6 }) => {
  const SkeletonCard = ({ isGrid = false }) => (
    <div className={`bg-white rounded-xl shadow-card overflow-hidden animate-pulse ${
      isGrid ? '' : 'flex flex-col md:flex-row'
    }`}>
      {/* Image Skeleton */}
      <div className={`bg-muted ${
        isGrid 
          ? 'h-48 w-full' :'h-48 md:h-auto md:w-80'
      }`} />
      
      {/* Content Skeleton */}
      <div className={`p-6 ${isGrid ? '' : 'flex-1'}`}>
        <div className="space-y-3">
          {/* Category & Badge */}
          <div className="flex items-center justify-between">
            <div className="h-4 bg-muted rounded w-24" />
            <div className="h-6 bg-muted rounded w-16" />
          </div>
          
          {/* Title */}
          <div className="space-y-2">
            <div className="h-6 bg-muted rounded w-3/4" />
            {!isGrid && <div className="h-6 bg-muted rounded w-1/2" />}
          </div>
          
          {/* Location */}
          <div className="h-4 bg-muted rounded w-1/3" />
          
          {/* Description (List view only) */}
          {!isGrid && (
            <div className="space-y-2">
              <div className="h-4 bg-muted rounded w-full" />
              <div className="h-4 bg-muted rounded w-2/3" />
            </div>
          )}
          
          {/* Rating */}
          <div className="flex items-center space-x-2">
            <div className="flex space-x-1">
              {[...Array(5)]?.map((_, i) => (
                <div key={i} className="h-4 w-4 bg-muted rounded" />
              ))}
            </div>
            <div className="h-4 bg-muted rounded w-16" />
          </div>
          
          {/* Features/Tags */}
          <div className="flex space-x-2">
            <div className="h-6 bg-muted rounded w-16" />
            <div className="h-6 bg-muted rounded w-20" />
            <div className="h-6 bg-muted rounded w-12" />
          </div>
          
          {/* Bottom Section */}
          <div className={`flex items-end justify-between mt-6 ${
            isGrid ? 'flex-col space-y-3' : ''
          }`}>
            {/* Duration & Group Size */}
            <div className="flex space-x-4">
              <div className="h-4 bg-muted rounded w-16" />
              <div className="h-4 bg-muted rounded w-20" />
            </div>
            
            {/* Price & Buttons */}
            <div className={`${isGrid ? 'w-full' : 'text-right'}`}>
              <div className="space-y-2 mb-3">
                <div className="h-4 bg-muted rounded w-16 ml-auto" />
                <div className="h-8 bg-muted rounded w-20 ml-auto" />
              </div>
              <div className="flex space-x-2">
                <div className="h-9 bg-muted rounded flex-1" />
                <div className="h-9 bg-muted rounded flex-1" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const MapSkeleton = () => (
    <div className="h-full bg-muted rounded-lg animate-pulse relative overflow-hidden">
      {/* Map Background */}
      <div className="w-full h-full bg-gradient-to-br from-muted to-muted-foreground/20" />
      
      {/* Skeleton Markers */}
      {[...Array(8)]?.map((_, index) => (
        <div
          key={index}
          className="absolute w-8 h-8 bg-white rounded-full shadow-lg"
          style={{
            left: `${20 + (index % 4) * 20}%`,
            top: `${20 + Math.floor(index / 4) * 30}%`,
            transform: 'translate(-50%, -50%)'
          }}
        />
      ))}
      
      {/* Controls Skeleton */}
      <div className="absolute top-4 right-4 space-y-2">
        <div className="w-10 h-10 bg-white rounded-lg shadow-md" />
        <div className="w-10 h-10 bg-white rounded-lg shadow-md" />
        <div className="w-10 h-10 bg-white rounded-lg shadow-md" />
      </div>
      
      {/* Legend Skeleton */}
      <div className="absolute bottom-4 right-4 bg-white rounded-lg shadow-md p-3 w-32">
        <div className="h-4 bg-muted rounded mb-2" />
        <div className="space-y-1">
          <div className="h-3 bg-muted rounded" />
          <div className="h-3 bg-muted rounded" />
        </div>
      </div>
    </div>
  );

  if (viewMode === 'map') {
    return <MapSkeleton />;
  }

  return (
    <div className={`space-y-6 ${
      viewMode === 'grid' ?'grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6' :''
    }`}>
      {[...Array(count)]?.map((_, index) => (
        <SkeletonCard key={index} isGrid={viewMode === 'grid'} />
      ))}
    </div>
  );
};

export default LoadingSkeleton;